export default __webpack_public_path__ + "static/media/home-hero.4af58b24.jpg";